import {
  CAMPAIGN_ATTRIBUTION_LOADING,
  CAMPAIGN_ATTRIBUTION_LOADED,
  CAMPAIGN_ATTRIBUTION_ERROR,
} from "../actions/campaignAttributionActions";

const initialState = {
  loading: false,
  error: null,
  headlines: {
    totalAttributedSignups: 0,
    uniqueCampaignCount: 0,
  },
  rows: [],
};

const campaignAttributionReducer = (state = initialState, action) => {
  switch (action.type) {
    case CAMPAIGN_ATTRIBUTION_LOADING:
      return { ...state, loading: true, error: null };

    case CAMPAIGN_ATTRIBUTION_LOADED:
      return {
        ...state,
        loading: false,
        error: null,
        headlines: action.payload.headlines || initialState.headlines,
        rows: action.payload.rows || [],
      };

    case CAMPAIGN_ATTRIBUTION_ERROR:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default campaignAttributionReducer;
